import * as React from "react";
import { IPage } from "../models/IPage.model";

const WishlistContext = React.createContext<IPage | null>(null);

export default WishlistContext;
